import { createElement } from 'react';

interface WeaveAccordionProps extends React.HTMLAttributes<HTMLElement> {
	className?: string;
	expanded?: boolean;
	label?: string;
	disabled?: boolean;
	indicatorposition?: 'left' | 'right';
	indicator?: 'caret' | 'operator';
	children: React.ReactNode;
}

export function WeaveAccordion({
	expanded = false,
	label,
	disabled = false,
	indicatorposition = 'left',
	indicator = 'caret',
	children,
	...rest
}: WeaveAccordionProps) {
	return createElement(
		'weave-accordion',
		{ expanded, label, disabled, indicatorposition, indicator, ...rest },
		children
	);
}
